/**
 * Visibilidad de la marca "Contabilizado" según el perfil del usuario.
 *
 * Regla de negocio (2026-09-08, pedida por el equipo contable):
 *  La marca es un instrumento de gestión INTERNA entre contadores. La ve quien
 *  puede contabilizar:
 *
 *   - root / contador (level === 'all')  → siempre
 *   - admin de la empresa activa         → siempre
 *   - cualquier usuario con el permiso `documents.accounting` → siempre
 *   - el resto (clientes)                → NUNCA
 *
 * Sustituye la regla del 2026-07-28, donde el cliente veía la marca si el
 * archivo tenía soporte contable adjunto. Se retiró a petición de las
 * contadoras: para el cliente la marca no significa nada del proceso que él
 * pueda comprobar, y exponía el estado interno del cierre contable.
 *
 * Marcar y desmarcar ya lo gatea el permiso `documents.accounting` en cada
 * vista; esto controla únicamente si se VE la etiqueta.
 *
 * Módulo puro: sin React/Redux/Firestore, para poder testearlo directo.
 */

/**
 * ¿El usuario pertenece al grupo que ve la marca?
 *
 * @param {object}  ctx
 * @param {boolean} ctx.isSuperAdmin  level === 'all' (root/contador)
 * @param {boolean} ctx.isAdmin       admin de la empresa activa
 * @param {boolean} ctx.canAccount    tiene documents.accounting (rol global o
 *                                    matriz efectiva de la carpeta)
 */
export const seesAccountedAlways = ({ isSuperAdmin, isAdmin, canAccount } = {}) =>
  !!isSuperAdmin || !!isAdmin || !!canAccount;

/**
 * ¿Debe mostrarse la etiqueta "Contabilizado" para este archivo y usuario?
 *
 * @param {object}  params
 * @param {object}  params.accounted   valor del campo `accounted` (o null)
 * @param {boolean} params.isSuperAdmin
 * @param {boolean} params.isAdmin
 * @param {boolean} params.canAccount  permiso documents.accounting del usuario
 * @returns {boolean}
 */
export const canSeeAccountedMark = ({
  accounted, isSuperAdmin, isAdmin, canAccount,
} = {}) => {
  if (!accounted) return false;
  return seesAccountedAlways({ isSuperAdmin, isAdmin, canAccount });
};

export default canSeeAccountedMark;
